import { FormControl, FormHelperText, InputLabel } from '@mui/material';
import React from 'react';
import { Controller } from 'react-hook-form';
import { MuiTelInput } from 'mui-tel-input';

const PhoneNumberInput = ({
  name,
  label,
  control,
  defaultValue,
  helperText,
  disabled,
  ...props
}) => {
  const normalizePhoneValue = (value) => {
    const normalized = String(value || '').trim();
    if (!normalized) {
      return '';
    }

    if (normalized.toLowerCase() === 'undefined' || normalized.toLowerCase() === 'null') {
      return '';
    }

    return normalized;
  };

  return (
    <Controller
      render={({ field: { onChange, onBlur, value } }) => (
        <FormControl fullWidth disabled={disabled} {...props}>
          <MuiTelInput
            variant="outlined"
            size="small"
            value={normalizePhoneValue(value)}
            onChange={(nextValue) => onChange(normalizePhoneValue(nextValue))}
            onBlur={onBlur}
            defaultCountry={'za'}
          />
          <FormHelperText error={props.error}>{helperText}</FormHelperText>
        </FormControl>
      )}
      name={name}
      control={control}
      defaultValue={defaultValue ?? ''}
    />
  );
};

export default PhoneNumberInput;
